import React from "react"
import styled from "@emotion/styled"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { FaChevronRight } from "react-icons/fa"

const FaqListBreadCrumbSectionWrapper = styled.div`
  width: 100%;
  position: relative;
  display: inline;
  padding: 30px 10px 20px;

  @media (max-width: 850px) {
    padding: 30px 0px 20px;
  }
`

const FaqListBreadCrumbList = styled.li`
  display: inline;
  font-family: "Gotham HTF Book";
  margin: 0px 5px 0px 0px;
  position: relative;
`

const FaqListBreadCrumbListLink = styled(Link)`
  font-family: "Gotham HTF Book";
  margin: 0px 5px 0px 0px;
  position: relative;
`

const FaqListBreadCrumbListLinkTitle = styled.span`
  font-family: "Gotham HTF Book";
  position: relative;
`

const FaqListBreadCrumbSection = ({
  intl,
  data,
  title,
  sidebarKey,
  catPage,
  productCatPage,
  productCatkey,
  productCatTitle,
}) => {
  return (
    data && (
      <FaqListBreadCrumbSectionWrapper>
        {data.faq_page_title && (
          <FaqListBreadCrumbList>
            <FaqListBreadCrumbListLink to={`/faq/`}>
              <FaqListBreadCrumbListLinkTitle
                dangerouslySetInnerHTML={{
                  __html: data.faq_page_title,
                }}
              />
            </FaqListBreadCrumbListLink>
            <FaChevronRight size={12} />
          </FaqListBreadCrumbList>
        )}

        {data.faq_list &&
          data.faq_list.list &&
          data.faq_list.list.map((item, index) => {
            return (
              item &&
              item.link &&
              item.title &&
              item.key === sidebarKey && (
                <FaqListBreadCrumbList key={index.toString()}>
                  {catPage ? (
                    <FaqListBreadCrumbListLinkTitle
                      dangerouslySetInnerHTML={{
                        __html: item.title,
                      }}
                    />
                  ) : (
                    <span>
                      <FaqListBreadCrumbListLink to={!catPage && item.link}>
                        <FaqListBreadCrumbListLinkTitle
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        />
                      </FaqListBreadCrumbListLink>
                      <FaChevronRight size={12} />
                    </span>
                  )}
                </FaqListBreadCrumbList>
              )
            )
          })}

        {!catPage &&
          !productCatkey &&
          data.faq_list &&
          data.faq_list.list &&
          data.faq_list.list.map((item, index) => {
            return (
              item &&
              item.key === sidebarKey &&
              item.item_list &&
              item.item_list.map((list_item, item_index) => {
                return (
                  list_item &&
                  list_item.item_title &&
                  list_item.item_title === title && (
                    <FaqListBreadCrumbList
                      key={item_index.toString()}
                      dangerouslySetInnerHTML={{
                        __html: list_item.item_title,
                      }}
                    />
                  )
                )
              })
            )
          })}

        {productCatPage &&
          data.faq_product_category &&
          data.faq_product_category.list &&
          data.faq_product_category.list.map((item, index) => {
            return (
              item &&
              item.link &&
              item.title &&
              item.key === productCatkey && (
                <FaqListBreadCrumbList key={index.toString()}>
                  {catPage ? (
                    <FaqListBreadCrumbListLinkTitle
                      dangerouslySetInnerHTML={{
                        __html: item.title,
                      }}
                    />
                  ) : (
                    <span>
                      <FaqListBreadCrumbListLink to={!catPage && item.link}>
                        <FaqListBreadCrumbListLinkTitle
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        />
                      </FaqListBreadCrumbListLink>
                      <FaChevronRight size={12} />
                    </span>
                  )}
                </FaqListBreadCrumbList>
              )
            )
          })}

        {productCatPage &&
          data.faq_product_category &&
          data.faq_product_category.list &&
          data.faq_product_category.list.map((item, index) => {
            return (
              item &&
              item.key === productCatkey &&
              item.item_list &&
              item.item_list.map((list_item, item_index) => {
                return (
                  list_item &&
                  list_item.item_title &&
                  list_item.item_title === productCatTitle && (
                    <FaqListBreadCrumbList
                      key={item_index.toString()}
                      dangerouslySetInnerHTML={{
                        __html: list_item.item_title,
                      }}
                    />
                  )
                )
              })
            )
          })}
      </FaqListBreadCrumbSectionWrapper>
    )
  )
}

export default injectIntl(FaqListBreadCrumbSection)
